import { render, staticRenderFns } from "./GroupBookingRejectConformationDialog.vue?vue&type=template&id=040ec734&scoped=true&"
import script from "./GroupBookingRejectConformationDialog.vue?vue&type=script&lang=js&"
export * from "./GroupBookingRejectConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ec734",
  null
  
)

export default component.exports